const form = document.querySelector('form');

const checkRequiredValue = () => {
  if (!form) {
    return;
  }

  const inputFirstName = form.querySelector('[name="first-name"]');
  const inputLastName = form.querySelector('[name="last-name"]');
  const inputTel = form.querySelector('[name="phone"]');
  const inputCheckPersonalData = form.querySelector('[name="personal-data"]');
  const inputUpload = form.querySelector('[data-upload]');
  const button = form.querySelector('[type="submit"]');

  if (inputFirstName.value &&
    inputLastName.value &&
    inputTel.value.length > 17 &&
    inputCheckPersonalData.checked &&
    !inputUpload.classList.contains('is-invalid')) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', true);
  }
};

const checkRequiredValueAfterInput = () => {
  if (!form) {
    return;
  }

  const inputFirstName = form.querySelector('[name="first-name"]');
  const inputLastName = form.querySelector('[name="last-name"]');
  const inputTel = form.querySelector('[name="phone"]');
  const inputCheckPersonalData = form.querySelector('[name="personal-data"]');
  const inputUpload = form.querySelector('[data-upload]');
  const button = form.querySelector('[type="submit"]');

  const checkInputHandler = (evt) => {
    evt.preventDefault();
    setTimeout(()=> {
      if (inputFirstName.value &&
        inputLastName.value &&
        inputTel.value.length > 17 &&
        inputCheckPersonalData.checked &&
        !inputUpload.classList.contains('is-invalid')) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', true);
      }
    }, 100)
  }

  form.addEventListener('input', checkInputHandler);
}

export {checkRequiredValue, checkRequiredValueAfterInput};
